export const PROTECTED_ROLE_NAMES = ['Administrator', 'Benutzer'] as const;

export const ADMIN_ROLE_IDENTIFIER = 'administration';

export function isProtectedRoleName(name: string | undefined | null): boolean {
    if (!name) return false;
    return PROTECTED_ROLE_NAMES.some((protectedName) => protectedName.toLowerCase() === name.trim().toLowerCase());
}

export function hasAdminRole(roles: string[] | undefined | null): boolean {
    if (!roles || !roles.length) return false;
    return roles.includes(ADMIN_ROLE_IDENTIFIER);
}
